import { Col, Row } from 'reactstrap';
import React, { useCallback } from 'react';
import SearchInput from 'components/SearchInput';
import { useApiGet } from 'hooks/useApi';
import Pagination from 'models/Pagination';
import PaginationNav from 'components/Pagination';
import { useNavigate } from 'react-router-dom';
import Icon from 'components/Icon';
import Table from 'components/Table';
import { Column } from 'components/Table/_presenters/props/tableComponentProps';
import { AdminSupportContact } from 'models/AdminSupportContact';
import moment from 'moment';

const AdminSupportContactsListPage = () => {
  const navigate = useNavigate();
  const [filteredData, setFilteredData] = React.useState({
    pageSize: 10,
    page: 1,
    search: ''
  });

  const { data: contactsPage, isLoading } = useApiGet<
    Pagination<AdminSupportContact>
  >('/admin/support/contacts', {
    params: filteredData
  });

  const handleSearch = useCallback(
    (search: string) => {
      setFilteredData({ ...filteredData, search, page: 1 });
    },
    [filteredData]
  );

  const handleClearFilter = useCallback(() => {
    setFilteredData({ pageSize: 10, page: 1, search: '' });
  }, []);

  const handlePageChange = useCallback(
    (page: number) => {
      setFilteredData({ ...filteredData, page });
    },
    [filteredData]
  );

  const goToDetail = useCallback(
    (contact: AdminSupportContact) => {
      navigate(`/admin/support/contacts/${contact.id}`);
    },
    [navigate]
  );

  const columns: Column<AdminSupportContact>[] = [
    {
      accessor: 'subject',
      label: 'Assunto',
      render: (subject) => <span className="fw-medium">{String(subject)}</span>
    },
    {
      accessor: 'user' as keyof AdminSupportContact,
      label: 'Usuário',
      render: (_: any, contact: AdminSupportContact) => (
        <span>{contact.user?.email || '-'}</span>
      )
    },
    {
      accessor: 'atendente' as keyof AdminSupportContact,
      label: 'Atendente',
      render: (_: any, contact: AdminSupportContact) => (
        <span>{contact.atendente?.email || '-'}</span>
      )
    },
    {
      accessor: 'createdAt',
      label: 'Data',
      render: (date) => <span>{moment(String(date)).format('L')}</span>
    },
    {
      accessor: 'actions',
      label: 'Ações',
      render: () => <Icon icon="eye" className="text-primary" />
    }
  ];

  return (
    <div className="padding-page">
      <Row className="d-flex flex-column flex-md-row">
        <Col className="col-12 col-md">
          <div>
            <p className="text-gray-600">Administração</p>
            <h4 className="fw-bold">Suporte</h4>
            <span className="small-typography text-gray-600">
              Visualize e gerencie os contatos de suporte dos clientes.
            </span>
          </div>
        </Col>
      </Row>
      <Row className="d-flex align-items-center mt-2 flex-column flex-md-row">
        <Col className="col-12 col-md">
          <SearchInput
            onClearFilter={handleClearFilter}
            onSearchTextChange={handleSearch}
            placeholder="Buscar contato"
          />
        </Col>
      </Row>
      <Table
        data={contactsPage?.items || []}
        columns={columns}
        isLoading={isLoading}
        onRowClick={goToDetail}
      />
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row mt-3">
        {contactsPage && (
          <PaginationNav
            onChange={handlePageChange}
            totalPages={contactsPage.totalPages}
            currentPage={contactsPage.page}
          />
        )}
      </div>
    </div>
  );
};

export default AdminSupportContactsListPage;
